import type { JsonObject } from "./types.js";

/** Whether a value is a plain JSON object — not null, not an array. */
export function isObject(value: unknown): value is JsonObject {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** A key escaped for a JSON pointer (RFC 6901): `~` as `~0`, `/` as `~1`. */
export function escapePointer(key: string): string {
  return key.replace(/~/g, "~0").replace(/\//g, "~1");
}
